import { useMemo } from 'react';

import { isPremiumEvent } from '@features/chessrussian/customizations/utils/event-filters';
import { getTournamentPgnLink } from '@features/shared/api/streams';
import { TournamentStatus } from '@features/shared/api/typings';
import { TournamentLinkBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentLinkBadge';

type Props = {
  tournament?: {
    tournamentId: string;
    status: TournamentStatus;
    entranceTicketSets?: string[][] | null;
  };
  isManager?: boolean;
  isAdmin?: boolean;
};

export function TournamentPgnBadge({ tournament, isManager, isAdmin }: Props) {
  const url = useMemo(
    () => (tournament?.tournamentId ? getTournamentPgnLink(tournament.tournamentId) : null),
    [tournament?.tournamentId],
  );

  if (
    !url ||
    (tournament?.status !== 'InProgress' &&
      tournament?.status !== 'Finished' &&
      tournament?.status !== 'Paused')
  ) {
    return null;
  }

  // ПГН платных турниров могут скачать только админы и менеджеры
  if (isPremiumEvent(tournament) && !isAdmin && !isManager) return null;

  return <TournamentLinkBadge href={url}>PGN турнира</TournamentLinkBadge>;
}
